import { render, staticRenderFns } from "./Jobrecruitmentdetails.vue?vue&type=template&id=71d59264&scoped=true&"
import script from "./Jobrecruitmentdetails.vue?vue&type=script&lang=js&"
export * from "./Jobrecruitmentdetails.vue?vue&type=script&lang=js&"
import style0 from "./Jobrecruitmentdetails.vue?vue&type=style&index=0&id=71d59264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d59264",
  null
  
)

export default component.exports